import ActionButton from 'components/ActionButton';
import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';
import qs from 'query-string';
import SearchBar from 'components/Autosuggest/Autosuggest';
import { searchAccountByName } from 'services/api/accounts';
import { sanitizeFilterObject } from 'utils';

const Filter = props => {
  const [name, setName] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const [accountId, setAccountId] = useState<string>('');
 
  useEffect(() => {
    const {
      name,
      email,
      accountId,
    } = qs.parse(props.location.search, { parseBooleans: true, parseNumbers: true });

    setName(name?.toString() || '');
    setEmail(email?.toString() || '');
    setAccountId(accountId?.toString() || '');
  }, []);
  
  const resetFilter = () => {
    setName('');
    setEmail('');
    setAccountId('');
    let filterData: Record<string, any> = {
      name: '',
      email: '',
      accountId: '',
    };
    filterData = sanitizeFilterObject(filterData);
    props.onSubmit(filterData);
  };

  const handleSubmit = () => {
    let filterData: Record<string, any> = {
      name,
      email,
      accountId,
    };
    filterData = sanitizeFilterObject(filterData);
    props.onSubmit(filterData);
  };

  const handleNameSelect = (suggestion: Record<string,any>) => {
    setName(suggestion?.name);
    setAccountId(suggestion?.objectId);
  };

  return (
    <form className={styles['filter-container']} onSubmit={handleSubmit}>
      <div className={styles['input-group']}>
        <div className={styles['label']}>Account ID</div>
        <input
          className={'form-control'}
          value={accountId}
          onChange={e => setAccountId(e.target.value)}
        />
      </div>
      <div className={styles['autosuggest-group']}>
        <div className={styles['label']}>Name</div>
        <div className={styles['autosuggest-input']}>
          <SearchBar
            isUser={false}
            value={name}
            setValue={value => setName(value)}
            searchAPI={searchAccountByName}
            searchAPIParamKey={'term'}
            onSuggestionClicked={handleNameSelect}
            suggestionTitleAccessor="name"
          />
        </div>
      </div>
      
      <div className={styles['input-group']}>
        <div className={styles['label']}>Email</div>
        <input
          className={'form-control'}
          value={email}
          onChange={e => setEmail(e.target.value)}
        />
      </div>
      <div className={styles['buttons-container']}>
        <ActionButton
          text={'Reset'}
          active={true}
          isLoading={false}
          onClick={resetFilter}
        />
        <ActionButton
          text={'Submit'}
          active={true}
          isSubmit={true}
          isLoading={false}
          onClick={handleSubmit}
        />
      </div>
    </form>
  );
};

export default Filter;